var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcBrowserFace(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11410_8383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0952 42.7302C28.4626 39.7823 35.5374 39.7823 41.9048 42.7302M22.5669 18.7937L16.907 28.6984M15.0204 20.6803L24.9252 26.3401M43.3197 18.7937L39.0748 28.6984M35.5374 21.3878L46.1497 26.3401M61.7143 32C61.7143 48.4107 48.4107 61.7143 32 61.7143C15.5892 61.7143 2.28571 48.4107 2.28571 32C2.28571 15.5893 15.5892 2.28572 32 2.28572C48.4107 2.28572 61.7143 15.5893 61.7143 32Z",
    stroke: "#6948EB",
    strokeWidth: 4.67,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11410_8383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcBrowserFace);
export default __webpack_public_path__ + "static/media/arc-browser-face.e02f9fd06e68667039347961291cb1d2.svg";
export { ForwardRef as ReactComponent };